import React from "react";
import { Navigate } from "react-router-dom";

import { usePermission } from "../Hooks";

export const PrivateRoute = ({
  element,
  permissions,
}: {
  element: React.ReactElement;
  permissions: string[];
}) => {
  return (
    <PermissionRoute permissions={permissions}>{element}</PermissionRoute>
  ) as JSX.Element;
};

const PermissionRoute = ({
  permissions,
  children,
}: {
  permissions?: string[];
  children: React.ReactNode;
}) => {
  const hasPermission = usePermission(permissions);

  return hasPermission ? (children as JSX.Element) : <Navigate to="/" />;
};
